import SignInView from '../components/sign_in/SignIn';

$(() => {
    const el = $('.SignInMainBody');
    let signInView = new SignInView(el, window.OverDrive.loginForms, window.OverDrive.forwardUrl, window.OverDrive.formKey, window.OverDrive.errorMessage, window.OverDrive.captchaRequired, window.OverDrive.showIdcSignUp);
    signInView._render();
});
